import { STORAGE_KEYS } from '@config/storage';

import { AdminAuthData } from '@types';

export type AuthData = AdminAuthData;

export const ensureIsRememberedLogin = (): boolean => {
  let result;
  try {
    result = JSON.parse(
      localStorage.getItem(STORAGE_KEYS.IS_REMEMBERED_LOGIN) ?? 'false'
    );
  } catch (error) {
    result = false;
  }

  return result;
};

export const readAuthData = (): undefined | AuthData => {
  const isRememberedLogin = ensureIsRememberedLogin();

  let rawAuthData;
  let authData;

  if (isRememberedLogin) {
    rawAuthData = localStorage.getItem(STORAGE_KEYS.ADMIN_AUTH);
  } else {
    rawAuthData = sessionStorage.getItem(STORAGE_KEYS.ADMIN_AUTH);
  }

  try {
    authData = JSON.parse(rawAuthData ?? '');
  } catch (error) {
    console.warn('No Auth token found');
    authData = undefined;
  }

  return authData;
};

export const writeAuthData = (data: AuthData): void => {
  const isRememberedLogin = ensureIsRememberedLogin();

  const processedAuthData = JSON.stringify(data);

  if (isRememberedLogin) {
    localStorage.setItem(STORAGE_KEYS.ADMIN_AUTH, processedAuthData);
  } else {
    sessionStorage.setItem(STORAGE_KEYS.ADMIN_AUTH, processedAuthData);
  }
};

export const removeAuthData = (): void => {
  const isRememberedLogin = ensureIsRememberedLogin();

  if (isRememberedLogin) {
    localStorage.removeItem(STORAGE_KEYS.ADMIN_AUTH);
  } else {
    sessionStorage.removeItem(STORAGE_KEYS.ADMIN_AUTH);
  }
};
